export const PRICES = 'Prices'
export const EARNINGS = 'Earnings'
export const TRENDS = 'Trends'
export const WEBSITES = 'Websites'
export const GRAPH = 'Graph'

export const MAX_ROWS=4;  //for small cards tables
